import React from 'react';
import styled from 'styled-components';
import BoxDefault from './Box';

const Wrapper = styled.div`
    position: absolute;
    background-color: white;
    margin-top: 0.5em;
    margin-right: 0.5em;
    max-width: 25em;
    z-index: 99;
`;

const Box = BoxDefault.extend`
    margin-bottom: 0;
    padding: 1.4em 2em;
`;

export default ({ children, toggle }) => (
    <Wrapper>
        <div onClick={toggle} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }} />
        <Box style={{ position: 'relative' }}>{children}</Box>
    </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/Dialog.tsx